
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.5 6.25a.75.75 0 000 1.5H5a.75.75 0 000-1.5h-.5zm4 0a.75.75 0 000 1.5h11a.75.75 0 000-1.5h-11zm0 5a.75.75 0 000 1.5h11a.75.75 0 000-1.5h-11zM7.75 17a.75.75 0 01.75-.75h11a.75.75 0 010 1.5h-11a.75.75 0 01-.75-.75zm-4-5a.75.75 0 01.75-.75H5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zm.75 4.25a.75.75 0 000 1.5H5a.75.75 0 000-1.5h-.5z"}})])
          )
        }
      }
    